module.exports = __webpack_public_path__ + "img/bar-chart.c1c2a244.svg";